import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import { schedulesSearchSchema } from '@/ui/pages/Reports/schedules/schedulesListModel';
import SchedulesPage from '@/ui/pages/Reports/schedules/SchedulesPage';

/**
 * HS-961 / HS-1603: the report schedules, a `@smartsash/data-screen` definition. Data comes from
 * the mock transport until HS-891 lands (`src/tmp/`). The definition is loaded inside the loader,
 * not named by the route, for the bundle reason `reports.index.tsx` explains.
 */
export const Route = createFileRoute('/_dashboard/reports/schedules/')({
  validateSearch: (input: Record<string, unknown>) => schedulesSearchSchema.parse(input),
  loaderDeps: ({ search }) => search,
  beforeLoad: requireRoute('/reports/schedules'),
  loader: async ({ context, deps }) => {
    const { schedulesScreen } = await import('@/ui/pages/Reports/schedules/schedulesScreen');
    return schedulesScreen.loaderFor()({ context, deps });
  },
  component: SchedulesPage,
});
